import { useState } from "react";

export default function DummyPasswordProtect({
  children,
  password,
}: {
  children: React.ReactNode;
  password: string;
}): JSX.Element {
  const [enteredPassword, setEnteredPassword] = useState("");

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const formData = new FormData(e.target as HTMLFormElement);
    setEnteredPassword(formData.get("password") as string);
  };

  return enteredPassword === password ? (
    <>{children}</>
  ) : (
    <div className="container py-10 px-2">
      <div className="max-w-[300px] mx-auto space-y-4">
        <h3 className="text-2xl font-bold">
          SFMTA Valencia Street Circulation Study
        </h3>
        <p className="text-sm">Enter password to see site</p>
        <form className="flex flex-col gap-2" onSubmit={handleSubmit}>
          <label>
            <span className="font-bold mr-2">Password</span>
            <input
              className="border border-gray-300 rounded-md p-2"
              type="password"
              name="password"
            />
          </label>
          <button className="bg-[#000] text-white p-2 rounded-md" type="submit">
            Submit
          </button>
        </form>
      </div>
    </div>
  );
}
